import React, { useState } from 'react';
import { profileApi } from '../../../services/api';
import AddEditModal from '../shared/AddEditModal';
import ItemCard from '../shared/ItemCard';

const certificationFields = [
    { name: 'name', label: 'اسم الشهادة', type: 'text', required: true, placeholder: 'AWS Solutions Architect' },
    {
        name: 'cert_type',
        label: 'النوع',
        type: 'select',
        required: true,
        options: [
            { value: 'certification', label: 'شهادة مهنية (امتحان)' },
            { value: 'course', label: 'شهادة إتمام دورة' },
            { value: 'program', label: 'برنامج تطوير مهارات' },
            { value: 'license', label: 'رخصة مهنية' },
            { value: 'bootcamp', label: 'برنامج تدريبي مكثف' }
        ]
    },
    { name: 'issuer', label: 'الجهة المانحة', type: 'text', placeholder: 'Amazon Web Services' },
    { name: 'issue_date', label: 'تاريخ الإصدار', type: 'month', placeholder: '2023-05' },
    { name: 'expiry_date', label: 'تاريخ الانتهاء', type: 'month', placeholder: '2026-05' },
    { name: 'credential_id', label: 'رقم الشهادة', type: 'text', placeholder: 'ABC123XYZ' },
    { name: 'credential_url', label: 'رابط التحقق', type: 'url', placeholder: 'https://verify.aws.com/...' },
    { name: 'skills_tags', label: 'المهارات', type: 'tags', placeholder: 'أضف مهارة...' },
    { name: 'importance', label: 'الأهمية', type: 'importance' }
];

export default function Certifications({ profile, onRefresh }) {
    const [showModal, setShowModal] = useState(false);
    const [editItem, setEditItem] = useState(null);
    const [loading, setLoading] = useState(false);

    const certifications = profile?.certifications || [];

    const handleAdd = () => {
        setEditItem(null);
        setShowModal(true);
    };

    const handleEdit = (item) => {
        setEditItem(item);
        setShowModal(true);
    };

    const handleDelete = async (id) => {
        if (!window.confirm('هل أنت متأكد من حذف هذه الشهادة؟')) return;
        setLoading(true);
        try {
            await profileApi.deleteCertification(id);
            onRefresh('certifications');
        } catch (err) {
            alert('فشل في حذف الشهادة');
        } finally {
            setLoading(false);
        }
    };

    const handleSave = async (data) => {
        setLoading(true);
        try {
            if (editItem) {
                await profileApi.updateCertification(editItem.id, data);
            } else {
                await profileApi.addCertification(data);
            }
            setShowModal(false);
            onRefresh('certifications');
        } catch (err) {
            alert('فشل في حفظ الشهادة');
        } finally {
            setLoading(false);
        }
    };

    const certTypeLabels = {
        certification: 'شهادة مهنية',
        course: 'شهادة دورة',
        program: 'برنامج مهارات',
        license: 'رخصة مهنية',
        bootcamp: 'برنامج مكثف'
    };

    const renderCard = (cert) => (
        <ItemCard
            key={cert.id}
            title={cert.name}
            subtitle={cert.issuer}
            badge={certTypeLabels[cert.cert_type] || 'شهادة'}
            meta={[
                cert.issue_date && `صدرت: ${cert.issue_date}`,
                cert.expiry_date && `تنتهي: ${cert.expiry_date}`
            ].filter(Boolean)}
            tags={cert.skills_tags}
            importance={cert.importance}
            onEdit={() => handleEdit(cert)}
            onDelete={() => handleDelete(cert.id)}
        />
    );

    return (
        <div className="section-container">
            <div className="section-header">
                <h2 className="section-title">الشهادات</h2>
                <button className="add-button" onClick={handleAdd}>
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                        <line x1="12" y1="5" x2="12" y2="19"></line>
                        <line x1="5" y1="12" x2="19" y2="12"></line>
                    </svg>
                    إضافة شهادة
                </button>
            </div>

            {certifications.length === 0 ? (
                <div className="empty-state">
                    <div className="empty-state-icon">
                        <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
                            <circle cx="12" cy="8" r="7"></circle>
                            <polyline points="8.21 13.89 7 23 12 20 17 23 15.79 13.88"></polyline>
                        </svg>
                    </div>
                    <h3 className="empty-state-title">لا توجد شهادات بعد</h3>
                    <p className="empty-state-description">أضف شهاداتك المهنية لتعزيز سيرتك الذاتية</p>
                    <button className="add-button" onClick={handleAdd}>أضف شهادتك الأولى</button>
                </div>
            ) : (
                <div className="items-grid">
                    {certifications.map(renderCard)}
                </div>
            )}

            {showModal && (
                <AddEditModal
                    title={editItem ? 'تعديل الشهادة' : 'إضافة شهادة'}
                    fields={certificationFields}
                    initialData={editItem || {}}
                    onSave={handleSave}
                    onClose={() => setShowModal(false)}
                    loading={loading}
                />
            )}
        </div>
    );
}
